import React, { Component } from "react";
import { can, canAny } from "../../utils/permission";
import {
  company,
  loading,
  float,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t, // นำเข้าฟังก์ชัน t
  activeOptions,
  random_charactor,
  sortOptions,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";

// เกณฑ์ความยาวรหัสผ่านตอนรีเซ็ต — ต้องตรงกับ ResetPasswordUserDto ฝั่ง backend
const PASSWORD_MIN = 6;
const PASSWORD_MAX = 20;
const PASSWORD_RANDOM_LENGTH = 12;

export default class UserManagement extends Component {
  isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 24,
      summary_count: {
        total: 0,
        active: 0,
        inactive: 0,
        roles: 0,
      },

      // Form States (Modal)
      full_name: "",
      nickname: "",
      email: "",
      phone: "",
      user_code: "",
      user_type: "",
      role_id: "",
      supervisor_id: "",
      department_id: "",
      is_active: "Active",
      password: "",
      company_list: [],

      // สิทธิ์การเข้าถึงตามแผนก (Department Access)
      department_access: [], // array ของ department uid
      dept_dropdown_open: false, // เปิด/ปิด dropdown สิทธิ์เข้าถึงแผนก
      dept_search: "", // ค้นหาแผนกใน dropdown

      // รีเซ็ตรหัสผ่าน (ไอคอนกุญแจ) — เห็นเฉพาะ super_user และ admin ที่มีสิทธิ์แก้ไขผู้ใช้
      can_reset_password: false,
      modal_reset: false,
      reset_user: null,
      reset_password: "",
      show_reset_password: false,

      // Mock Data: User List
      data: [],
      data_role: [],
      data_supervisor: [],
      data_department: [],
      data_department_full: [], // ข้อมูลแผนกแบบเต็ม (uid/name/department_code) สำหรับ dropdown สิทธิ์
    };
  }

  async componentDidMount() {
    loading(false);
    this.setState({ can_reset_password: this.canResetPassword() });
    this.Get(1);
  }

  // สิทธิ์ใช้ปุ่มรีเซ็ตรหัสผ่าน: super_user ใช้ได้ทันที ส่วน admin ต้องมี permission users.update
  canResetPassword = () => {
    let user_profile = null;
    try {
      user_profile = JSON.parse(localStorage.getItem("cm-profile") || "null");
    } catch (e) {
      return false;
    }
    if (user_profile?.user_type === "super_user") return true;
    if (user_profile?.user_type === "admin") {
      return (user_profile?.role?.permission || []).includes("users.update");
    }
    return false;
  };

  Get = async (page) => {
    const { filter_search, filter_status } = this.state;
    let data, count, data_role, data_supervisor, data_department, data_department_full;
    loading(true);

    // จำลองการเรียก API
    let [result, result_all_users, result_role, result_supervisor, result_department] = await Promise.all([
      GET("admin/users", { page_size: 10, page: page, data_search: filter_search || "", is_active: filter_status || "" }),
      GET("admin/users", { page_size: 10000, page: 0 }),
      GET("admin/roles", { page_size: 100, page: 0, data_search: "" }),
      // ผู้บริหาร/หัวหน้าเซลล์เลือกเป็นผู้บังคับบัญชาได้เช่นเดียวกับ supervisor
      GET("admin/users", { page_size: 1000, page: 0, data_search: "", user_type: "supervisor,executive,sales_manager"}),
      GET("admin/departments", { page_size: 1000, page: 0, data_search: "" }),
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }
    if (result_role?.status) {
      data_role = result_role.data;
    }
    if (result_supervisor?.status) {
      data_supervisor = result_supervisor.data?.map(e=>({is_active: e.is_active, value:e.uid, label: e.full_name}));
    }
    if (result_department?.status) {
      data_department_full = result_department.data || [];
      data_department = data_department_full.map(e=>({is_active: e.is_active, value:e.uid, label: e.name}));
    }

    const allUsers = result_all_users?.status ? result_all_users.data || [] : [];
    const summary_count = {
      total: result?.pagination?.count || allUsers.length || 0,
      active: allUsers.filter((item) => item?.is_active).length,
      inactive: allUsers.filter((item) => item?.is_active === false).length,
      roles: Array.isArray(data_role) ? data_role.length : 0,
    };

    this.setState({ data, count, summary_count, data_role, data_supervisor, data_department, data_department_full });
    loading(false);
  };

  // เปิด modal แก้ไข — ดึงข้อมูลรายตัวเพื่อให้ได้ department_access ครบ
  Edit = async (item) => {
    loading(true);
    let result = await GET("admin/users", { uid: item.uid });
    const data = result?.status && result.data ? result.data : item;
    this.setState({
      modal_update: true,
      uid: data.uid,
      full_name: data.full_name || "",
      nickname: data.nickname || "",
      email: data.email || "",
      phone: data.phone || "",
      user_code: data.user_code || "",
      user_type: data.user_type || "",
      role_id: data.role?.uid || "",
      supervisor_id: data.supervisor?.uid || "",
      department_id: data.department?.uid || "",
      company_list: data.company_list?.map((e) => e.uid) || [],
      is_active: data.is_active ? "Active" : "Inactive",
      password: "",
      department_access: data.department_access || [],
      dept_dropdown_open: false,
      dept_search: "",
    });
    loading(false);
  };

  // --- Department Access Management (สิทธิ์เข้าถึงตามแผนก) ---
  // เลือกแผนกต้นสังกัด — lock เข้าใน department_access เสมอ
  setHomeDepartment = (uid) => {
    this.setState((prev) => {
      const access = prev.department_access.filter((d) => d !== prev.department_id); // ถอดแผนกต้นสังกัดเดิมออกก่อน
      if (uid && !access.includes(uid)) access.push(uid);
      return { department_id: uid, department_access: access };
    });
  };

  toggleDepartmentAccess = (uid) => {
    if (uid === this.state.department_id) return; // แผนกต้นสังกัด lock ไว้ ลบไม่ได้
    this.setState((prev) => ({
      department_access: prev.department_access.includes(uid)
        ? prev.department_access.filter((d) => d !== uid)
        : [...prev.department_access, uid],
    }));
  };

  toggleSelectAllDepartments = () => {
    this.setState((prev) => {
      // "เลือกทั้งหมด" ต้องหมายถึงเฉพาะแผนกที่เปิดใช้งาน (บวกแผนกเดิมที่ถูกกำหนดไว้แล้ว)
      const allUids = activeOptions(prev.data_department_full, [...prev.department_access, prev.department_id], {
        keys: ["uid"],
        mark: false,
      }).map((d) => d.uid);
      const allSelected = allUids.length > 0 && allUids.every((u) => prev.department_access.includes(u));
      return {
        department_access: allSelected
          ? (prev.department_id ? [prev.department_id] : [])
          : allUids,
      };
    });
  };

  CreateUpdate = async () => {
    const {
      uid,
      user_type,
      role_id,
      department_id,
      supervisor_id,
      full_name,
      nickname,
      phone,
      user_code,
      email,
      password,
      modal_create,
      modal_update,
      is_active,
      company_list,
      department_access,
    } = this.state;
    const normalizedEmail = email.trim();

    if (!full_name.trim()) {
      alert("", "warning", t("warning"), t("verify_full_name"));
      return;
    } else if (!user_code.trim()) {
      alert("", "warning", t("warning"), t("verify_user_code"));
      return;
    } else if (!normalizedEmail) {
      alert("", "warning", t("warning"), t("verify_contact_email"));
      return;
    } else if (!this.isValidEmail(normalizedEmail)) {
      alert("", "warning", t("warning"), t("invalid_email_address"));
      return;
    } else if (!user_type.trim()) {
      alert("", "warning", t("warning"), t("verify_user_type"));
      return;
    } else if (!role_id.trim()) {
      alert("", "warning", t("warning"), t("verify_role_id"));
      return;
    } else if (modal_create && !password) {
      alert("", "warning", t("warning"), t("verify_password"));
      return;
    } else if (!department_id.trim()) {
      alert("", "warning", t("warning"), t("verify_department"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let body = {
        user_type,
        role_id,
        // ISS-032: เดิมไม่ได้ส่ง user_code ขึ้นไปเลย (validate ว่าห้ามว่างแต่ไม่ส่ง)
        // backend จึงตอบ success แต่ค่าไม่เปลี่ยน ตอนสร้างใหม่ถ้าส่งค่ามา backend จะใช้ค่านี้แทนการรันเลขอัตโนมัติ
        user_code,
        // ประเภทที่ซ่อนฟิลด์ผู้บังคับบัญชา ต้องส่งค่าว่างเสมอ กันค่าเดิมค้างตอนเปลี่ยนประเภท
        // ใช้ "-" เพราะ removeEmptyString (api.js) ตัดคีย์ "" ทิ้ง แต่ "-" จะถูกแปลงเป็น "" ให้ -> backend ล้างหัวหน้าเป็น null
        supervisor_id: this.hasSupervisorField(user_type) ? (supervisor_id || "-") : "-",
        department_id,
        full_name,
        nickname: nickname.trim(),
        phone,
        email: normalizedEmail,
        picture: "",
        company_list,
        is_active: is_active === "Active" ? true : false,
        // ส่ง department_access เฉพาะตอนบันทึกจาก modal — เลี่ยงเขียนทับสิทธิ์ตอน quick action (ปิดใช้งาน)
        ...((modal_create || modal_update) ? { department_access } : {}),
      };

      // ส่ง password เฉพาะตอนสร้างผู้ใช้ใหม่เท่านั้น (ตอนแก้ไขไม่ส่งไป API)
      if (!uid) {
        body.password = password;
      }

      let result = !uid
        ? await POST("admin/users", body)
        : await PUT("admin/users/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        // this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || "An error occurred.",
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
      if (!id) return;
      if (
        await alert(
          "",
          "warning",
          t("delete_item"),
          t("delete_desc"),
          t("confirm"),
          t("cancel"),
        )
      ) {
        loading(true);
        let result = await DELETE("admin/users/" + id, null);
        if (result?.status) {
          alert("#", "success");
          this.setState({ modal_create: false, modal_update: false });
          this.Get(1);
        } else {
          alert("", "warning", t("warning"), result?.message || "An error occurred.");
        }
        loading(false);
      }
    };

  // --- Reset Password (ผู้ดูแลตั้งรหัสผ่านใหม่ให้ผู้ใช้) ---
  passwordRuleText = () =>
    t("password_length_rule").replace("{min}", PASSWORD_MIN).replace("{max}", PASSWORD_MAX);

  // สุ่มรหัสผ่าน 12 ตัว (A-Z a-z 0-9) — บังคับให้มีครบทั้งพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข อย่างละอย่างน้อย 1 ตัว
  GenerateRandomPassword = () => {
    const pick = (set) => set.charAt(Math.floor(Math.random() * set.length));
    const chars = [
      pick("ABCDEFGHIJKLMNOPQRSTUVWXYZ"),
      pick("abcdefghijklmnopqrstuvwxyz"),
      pick("0123456789"),
      ...random_charactor(PASSWORD_RANDOM_LENGTH - 3).split(""),
    ];

    // สลับตำแหน่ง (Fisher-Yates) กันไม่ให้ 3 ตัวแรกเป็นรูปแบบเดิมทุกครั้ง
    for (let i = chars.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [chars[i], chars[j]] = [chars[j], chars[i]];
    }

    // เปิดให้เห็นรหัสที่สุ่มได้ทันที ผู้ดูแลจะได้จดหรือคัดลอกไปแจ้งผู้ใช้
    this.setState({ reset_password: chars.join(""), show_reset_password: true });
  };

  OpenResetPassword = (item) => {
    this.setState({
      modal_reset: true,
      reset_user: item,
      reset_password: "",
      show_reset_password: false,
    });
  };

  CloseResetPassword = () => {
    this.setState({ modal_reset: false, reset_user: null, reset_password: "", show_reset_password: false });
  };

  ResetPassword = async () => {
    const { reset_user, reset_password } = this.state;
    if (!reset_user?.uid) return;

    const newPassword = reset_password.trim();
    if (!newPassword) {
      alert("", "warning", t("warning"), t("verify_password"));
      return;
    } else if (newPassword.length < PASSWORD_MIN || newPassword.length > PASSWORD_MAX) {
      alert("", "warning", t("warning"), this.passwordRuleText());
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("reset_password_confirm"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      // API นี้อัปเดตเฉพาะรหัสผ่าน และล้าง token ของผู้ใช้เพื่อบังคับให้ login ใหม่
      let result = await PUT("admin/users/" + reset_user.uid + "/reset-password", { password: newPassword });
      if (result?.status === true) {
        this.CloseResetPassword();
        alert("", "success");
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  // แปลงรหัสประเภทผู้ใช้งานเป็นข้อความตามภาษา (ใช้ key ชุดเดียวกับ dropdown ในโมดัล)
  formatUserType = (value) => {
    const labels = {
      super_user: "super_admin",
      "admin-company": "admin_company",
      executive: "executive",
      supervisor: "supervisor",
      sales_manager: "sales_manager",
      sales: "sales",
      admin: "admin",
      customer: "customer",
      technician: "technician",
      warehouse: "warehouse",
    };
    return labels[value] ? t(labels[value]) : (value || "-");
  };

  // ผู้บริหาร/ผู้บังคับบัญชาอยู่บนสุดของสายบังคับบัญชาแล้ว จึงไม่ต้องมีฟิลด์ผู้บังคับบัญชา
  // หัวหน้าเซลล์/พนักงานขายเลือกหัวหน้าได้ (ลูกค้าขอเพิ่มให้หัวหน้าเซลล์ 27 ต.ค. 2569)
  hasSupervisorField = (userType) => !["executive", "supervisor"].includes(userType);

  render() {
    const {
      uid,
      data,
      count,
      summary_count,
      data_role,
      data_supervisor,
      data_department,
      data_department_full,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      full_name,
      nickname,
      email,
      password,
      phone,
      user_type,
      user_code,
      role_id,
      supervisor_id,
      department_id,
      is_active,
      company_list,
      department_access,
      dept_dropdown_open,
      dept_search,
      can_reset_password,
      modal_reset,
      reset_user,
      reset_password,
      show_reset_password,
    } = this.state;
    const emailHasError = Boolean(email.trim()) && !this.isValidEmail(email);
    // แผนกที่เลือกใช้งานได้: เฉพาะที่เปิดใช้งาน + แผนกที่ผู้ใช้คนนี้ถูกกำหนดไว้แล้ว (กันสิทธิ์เดิมหายตอนแก้ไข)
    const departmentAccessOptions = activeOptions(data_department_full, [...department_access, department_id], {
      keys: ["uid"],
      mark: false,
    });

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("user_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_users_desc")}</div>
                    </div>
                    {can("users.create") && (
                      <button
                          className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                          onClick={() =>
                              this.setState({
                                  modal_create: true,
                                  full_name: "",
                                  nickname: "",
                                  email: "",
                                  phone: "",
                                  user_code: "",
                                  user_type: "",
                                  role_id: "",
                                  supervisor_id: "",
                                  department_id: "",
                                  is_active: "Active",
                                  password: "",
                                  company_list: [company?.id],
                                  department_access: [],
                                  dept_dropdown_open: false,
                                  dept_search: "",
                              })
                          }
                      >
                          <span className="me-2 text-16">+</span> {t("add_user")}
                      </button>
                    )}
                </div>

                {/* Top KPI Cards (4 Columns) */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_users")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{summary_count.total}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">{"\uf0c0"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_users")}</div>
                                    <h4 className="fw-bold text-success mb-0">{summary_count.active}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_users")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{summary_count.inactive}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <div className="position-relative flex-grow-1" style={{ maxWidth: "350px" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                            <input
                                type="text"
                                className="form-control ps-5 wpx-350"
                                placeholder={t("search_users")}
                                value={filter_search}
                                onChange={(e) => this.setState({ filter_search: e.target.value })}
                                onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                            />
                        </div>
                        <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                            <option value="">{t("all_status")}</option>
                            <option value="true">{t("active")}</option>
                            <option value="false">{t("inactive")}</option>
                        </select>
                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                {t("filter")}
                            </button>
                            <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}>
                                {t("clear_all")}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Users Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("user_col")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("email")}</th>
                                    <th className="py-3 border-0">{t("user_type")}</th>
                                    <th className="py-3 border-0">{t("department")}</th>
                                    <th className="py-3 border-0">{t("role")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* User Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    {item.full_name?.slice(0, 2)?.toUpperCase() || "-"}
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item?.full_name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("user_code")}: {item?.user_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Email */}
                                        <td>
                                            <div className="text-secondary text-14">{item.email}</div>
                                        </td>

                                        {/* User Type */}
                                        <td>
                                            <div className="text-secondary text-14">{this.formatUserType(item.user_type)}</div>
                                        </td>

                                        {/* Department */}
                                        <td>
                                            <div className="text-secondary text-14">{item.department?.name || "-"}</div>
                                        </td>

                                        {/* Role */}
                                        <td>
                                            <span className={`badge bg-primary-light text-primary rounded-pill px-2 py-1 fw-bold text-10 border border-primary`}>{item.role?.name || "-"}</span>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                <ActionIconButton label={canAny("users.update", "users.delete") ? t("edit") : t("view")} icon={canAny("users.update", "users.delete") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={canAny("users.update", "users.delete") ? "warning" : "primary"} onClick={() => this.Edit(item)} />
                                                {can_reset_password && (
                                                    <ActionIconButton
                                                        label={t("reset_password")}
                                                        icon={ACTION_ICONS.key}
                                                        variant="warning"
                                                        onClick={() => this.OpenResetPassword(item)}
                                                    />
                                                )}
                                                {can("users.delete") && <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item.uid)} />}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data.length} {t("of")} {count} {t("users_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD NEW USER */}
            <Modal
                size="lg"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_user") : t("add_new_user")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={modal_update && !can("users.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf007"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("full_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control py-2" value={full_name} placeholder={t("full_name")} onChange={(e) => this.setState({ full_name: e.target.value })} />
                                </div>
                                {/* ซ่อนช่องชื่อเล่นไว้ก่อน ยังไม่ใช้งาน */}
                                {false && (
                                    <div className="col-md-6">
                                        <label className="form-label text-14 text-dark mb-2">{t("nickname")}</label>
                                        <input type="text" className="form-control py-2" value={nickname} placeholder={t("nickname")} onChange={(e) => this.setState({ nickname: e.target.value })} />
                                    </div>
                                )}
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">{t("phone")}</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        value={phone}
                                        maxLength={10}
                                        onChange={(e) => {
                                            if (!float(e.target.value)) return;
                                            this.setState({ phone: e.target.value });
                                        }}
                                        placeholder={t("phone")}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("user_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        value={user_code}
                                        maxLength={100}
                                        onChange={(e) => {
                                            this.setState({ user_code: e.target.value });
                                        }}
                                        placeholder={t("user_code")}
                                    />
                                </div>
                                {/* Department */}
                                <div className="col-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("department")} <span className="text-danger">*</span>
                                    </label>
                                    <select className="form-select py-2" value={department_id} onChange={(e) => this.setHomeDepartment(e.target.value)}>
                                        <option value="">{t("select_department")}</option>
                                        {sortOptions(activeOptions(data_department, department_id)).map((sv) => (
                                            <option key={sv.value} value={sv.value}>
                                                {sv.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("email")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        className={`form-control py-2 ${emailHasError ? "is-invalid" : ""}`}
                                        value={email}
                                        placeholder={t("email")}
                                        onChange={(e) => this.setState({ email: e.target.value })}
                                    />
                                    {emailHasError && <div className="invalid-feedback d-block">{t("invalid_email_address")}</div>}
                                </div>
                                {!modal_update && (
                                    <div className="col-md-6">
                                        <label className="form-label text-14 text-dark mb-2">
                                            {t("password")} <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control py-2"
                                            value={password}
                                            placeholder={t("password")}
                                            onChange={(e) => this.setState({ password: e.target.value })}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* User type */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf058"}</span> {t("role_assignment")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("role_assignment_desc")}</small>
                        </div>
                        <div className="col-6 mt-0 mb-3">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("user_type")} <span className="text-danger">*</span>
                            </label>
                            <select
                                className="form-select py-2"
                                value={user_type}
                                // ช่างเทคนิค/ลูกค้าเดิมห้ามเปลี่ยนประเภทจากหน้านี้ — ข้อมูลผูกกับ record ช่างเทคนิค/ลูกค้า
                                disabled={Boolean(uid) && ["technician", "customer"].includes(user_type)}
                                onChange={(e) => {
                                    const next = e.target.value;
                                    // เปลี่ยนไปประเภทที่ไม่ใช้ผู้บังคับบัญชา ให้ล้างค่าที่เลือกไว้ทิ้ง
                                    this.setState({ user_type: next, ...(this.hasSupervisorField(next) ? {} : { supervisor_id: "" }) });
                                }}
                            >
                                <option value="">{t("select_user_type")}</option>
                                {/* <option value="admin-company">{t("admin_company")}</option> */}
                                <option value="executive">{t("executive")}</option>
                                <option value="supervisor">{t("supervisor")}</option>
                                <option value="sales_manager">{t("sales_manager")}</option>
                                <option value="sales">{t("sales")}</option>
                                <option value="admin">{t("admin")}</option>
                                {/* ช่างเทคนิค/ลูกค้าต้องสร้างจากเมนูของตัวเอง (ต้องผูกกับ record ช่างเทคนิค/ลูกค้า)
                                    ตอนเพิ่มผู้ใช้จึงไม่ให้เลือก แต่ตอนแก้ไข user เดิมต้องคงตัวเลือกไว้ ไม่งั้น select แสดงค่าว่าง */}
                                {Boolean(uid) && user_type === "customer" && <option value="customer">{t("customer")}</option>}
                                {Boolean(uid) && user_type === "technician" && <option value="technician">{t("technician")}</option>}
                                <option value="warehouse">{t("warehouse")}</option>
                            </select>
                            {!uid && <small className="text-muted text-12 d-block mt-1">{t("restricted_user_type_hint")}</small>}
                        </div>
                        {/* Role Assignment */}
                        <div className="col-6 mt-0 mb-3">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("role")} <span className="text-danger">*</span>
                            </label>
                            {/* ลูกค้าผูกกับบทบาทเริ่มต้นของลูกค้าเสมอ (ระบบกำหนดให้) เปลี่ยนจากหน้านี้ไม่ได้ */}
                            <select
                                className="form-select py-2"
                                value={role_id}
                                disabled={user_type === "customer"}
                                onChange={(e) => this.setState({ role_id: e.target.value })}
                            >
                                <option value="">{t("select_role")}</option>
                                {sortOptions(activeOptions(data_role, role_id, { keys: ["uid"] }), { by: "name" }).map((role) => (
                                    <option key={role.uid} value={role.uid}>
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {user_type === "customer" && (
                            <div className="col-12 mt-0 mb-3">
                                <small className="text-muted text-12">{t("customer_role_locked_hint")}</small>
                            </div>
                        )}
                        {/* Supervisor — ผู้บริหาร/ผู้บังคับบัญชาไม่ใช้ฟิลด์นี้ */}
                        {this.hasSupervisorField(user_type) && (
                            <div className="col-6 mt-0 mb-3">
                                <label className="form-label text-14 text-dark mb-2">{t("supervisor")}</label>
                                <select className="form-select py-2" value={supervisor_id} onChange={(e) => this.setState({ supervisor_id: e.target.value })}>
                                    <option value="">{t("select_supervisor")}</option>
                                    {sortOptions(activeOptions(data_supervisor, supervisor_id)).filter((sv) => !uid || sv.value !== uid).map((sv) => (
                                        <option key={sv.value} value={sv.value}>
                                            {sv.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* (Department Access) */}
                        <div className="col-12 mt-3 border-top pt-4">
                            <label className="form-label text-14 text-dark mb-2 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf1ad"}</span> {t("department_access")}
                            </label>
                            <div className="text-warning rounded-3 text-12 mb-2 d-flex align-items-center">
                                <span className="icon me-2">{"\uf05a"}</span> {t("department_access_desc")}
                            </div>
                            <div className="position-relative">
                                <div
                                    className={`form-control d-flex align-items-center ${dept_dropdown_open ? "border-primary" : ""}`}
                                    style={{ minHeight: "48px", height: "auto", cursor: "pointer" }}
                                    onClick={() => this.setState({ dept_dropdown_open: !dept_dropdown_open })}
                                >
                                    <div className="d-flex flex-wrap gap-2 align-items-center flex-grow-1 py-1">
                                        {department_access.length === 0 && <span className="text-secondary text-12">{t("department_access_empty")}</span>}
                                        {department_access.map((depUid) => {
                                            const dep = data_department_full.find((d) => d.uid === depUid);
                                            const locked = depUid === department_id;
                                            return (
                                                <span key={depUid} className="badge bg-primary-light text-primary border border-primary px-2 py-2 fw-medium text-12 d-inline-flex align-items-center">
                                                    {dep?.department_code || dep?.name || depUid}
                                                    {locked ? (
                                                        <span className="icon ms-2 text-12">{"\uf023"}</span>
                                                    ) : (
                                                        <span
                                                            className="icon ms-2 text-12 cursor-pointer text-danger"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.toggleDepartmentAccess(depUid);
                                                            }}
                                                        >
                                                            {"\uf00d"}
                                                        </span>
                                                    )}
                                                </span>
                                            );
                                        })}
                                    </div>
                                    <span className="icon text-secondary ms-2">{dept_dropdown_open ? "\uf077" : "\uf078"}</span>
                                </div>

                                {dept_dropdown_open && (
                                    <>
                                        <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ dept_dropdown_open: false, dept_search: "" })} />
                                        <div className="position-absolute bg-white border rounded-3 shadow w-100 mt-1 p-2" style={{ zIndex: 1050, maxHeight: "320px", overflowY: "auto" }}>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder={t("search")}
                                                value={dept_search}
                                                onChange={(e) => this.setState({ dept_search: e.target.value })}
                                            />
                                            <label className="d-flex align-items-center gap-2 px-2 py-2 border-bottom fw-bold text-dark mb-1" style={{ cursor: "pointer" }}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input mt-0"
                                                    checked={departmentAccessOptions.length > 0 && departmentAccessOptions.every((d) => department_access.includes(d.uid))}
                                                    onChange={this.toggleSelectAllDepartments}
                                                />
                                                {t("department_access_select_all")}
                                            </label>
                                            {departmentAccessOptions
                                                .filter(
                                                    (d) =>
                                                        !dept_search ||
                                                        (d.name || "").toLowerCase().includes(dept_search.toLowerCase()) ||
                                                        (d.department_code || "").toLowerCase().includes(dept_search.toLowerCase())
                                                )
                                                .map((d) => {
                                                    const checked = department_access.includes(d.uid);
                                                    const locked = d.uid === department_id;
                                                    return (
                                                        <label
                                                            key={d.uid}
                                                            className="d-flex align-items-center gap-2 px-2 py-2 rounded-2 hover-bg-light"
                                                            style={{ cursor: locked ? "not-allowed" : "pointer" }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input mt-0"
                                                                checked={checked}
                                                                disabled={locked}
                                                                onChange={() => this.toggleDepartmentAccess(d.uid)}
                                                            />
                                                            <span className="badge bg-primary-light text-primary border border-primary px-2 py-1 text-12">{d.department_code || "-"}</span>
                                                            <span className="text-14 text-dark">{d.name}</span>
                                                            {locked && <span className="icon ms-auto text-secondary text-12">{"\uf023"}</span>}
                                                        </label>
                                                    );
                                                })}
                                            {departmentAccessOptions.filter(
                                                (d) =>
                                                    !dept_search ||
                                                    (d.name || "").toLowerCase().includes(dept_search.toLowerCase()) ||
                                                    (d.department_code || "").toLowerCase().includes(dept_search.toLowerCase())
                                            ).length === 0 && <div className="text-center text-secondary text-12 py-3">{t("department_access_not_found")}</div>}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("status_desc")}</small>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="userStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="userStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
                    <div>
                        {modal_update && can("users.delete") && (
                            <button
                                className="btn btn-outline-danger px-4 py-2 rounded-3 fw-bold d-flex align-items-center bg-danger-light border-danger text-danger"
                                onClick={() => this.Delete(uid)}
                            >
                                <span className="icon me-2">{"\uf2ed"}</span> {t("delete_data")}
                            </button>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            {t("cancel")}
                        </button>
                        {(modal_create || can("users.update")) && (
                          <button
                              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                              style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                              onClick={() => {
                                  this.CreateUpdate();
                              }}
                          >
                              <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                          </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL: RESET PASSWORD */}
            <Modal
                show={modal_reset}
                onHide={this.CloseResetPassword}
                centered
                contentClassName="border-0 rounded-4 shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{t("reset_password")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    {/* ข้อมูลผู้ใช้งานที่กำลังรีเซ็ตรหัสผ่าน (อ่านอย่างเดียว) */}
                    <h6 className="fw-bold mb-1 d-flex align-items-center">
                        <span className="icon text-primary me-2">{"\uf007"}</span> {t("user_information")}
                    </h6>
                    <small className="text-muted d-block mb-3">{t("reset_password_desc")}</small>

                    <div className="bg-light rounded-3 p-3 mb-4">
                        <div className="row g-2 text-14">
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("full_name")}</div>
                                <div className="fw-bold text-dark">{reset_user?.full_name || "-"}</div>
                            </div>
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("user_code")}</div>
                                <div className="fw-bold text-dark">{reset_user?.user_code || "-"}</div>
                            </div>
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("email")}</div>
                                <div className="text-dark text-break">{reset_user?.email || "-"}</div>
                            </div>
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("user_type")}</div>
                                <div className="text-dark">{this.formatUserType(reset_user?.user_type)}</div>
                            </div>
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("department")}</div>
                                <div className="text-dark">{reset_user?.department?.name || "-"}</div>
                            </div>
                            <div className="col-6">
                                <div className="text-secondary text-12">{t("role")}</div>
                                <div className="text-dark">{reset_user?.role?.name || "-"}</div>
                            </div>
                            <div className="col-12">
                                <div className="text-secondary text-12">{t("status")}</div>
                                {reset_user?.is_active ? (
                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                ) : (
                                    <span className="text-secondary text-12 fw-bold bg-white px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="form-label text-14 text-dark mb-0">
                            {t("new_password")} <span className="text-danger">*</span>
                        </label>
                        <button
                            type="button"
                            className="btn btn-white border px-3 py-1 rounded-3 fw-bold text-12 text-primary d-flex align-items-center"
                            onClick={this.GenerateRandomPassword}
                        >
                            <span className="icon me-2">{"\uf0d0"}</span> {t("random_password")}
                        </button>
                    </div>
                    <div className="position-relative">
                        <input
                            type={show_reset_password ? "text" : "password"}
                            className="form-control py-2 pe-5"
                            value={reset_password}
                            placeholder={t("new_password")}
                            maxLength={PASSWORD_MAX}
                            autoComplete="new-password"
                            onChange={(e) => this.setState({ reset_password: e.target.value })}
                        />
                        {/* ไอคอนตาอยู่ในกรอบ input (input มี pe-5 เผื่อที่ไว้แล้ว) */}
                        <span
                            className="icon text-secondary pointer position-absolute top-50 end-0 translate-middle-y me-3"
                            title={t("new_password")}
                            onClick={() => this.setState({ show_reset_password: !show_reset_password })}
                        >
                            {show_reset_password ? "\uf070" : "\uf06e"}
                        </span>
                    </div>
                    <small className="text-muted d-block mt-2">{this.passwordRuleText()}</small>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.CloseResetPassword}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => this.ResetPassword()}
                    >
                        <span className="icon me-2">{"\uf084"}</span> {t("reset_password")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
